import React, { useEffect, lazy, Suspense } from 'react'
import { Box, Flex, Skeleton, Spinner } from '@chakra-ui/react'
import TextImageBlock from '../components/TextImageBlock'
import Footer from '../components/Footer'
import { useParams } from 'react-router-dom'
import video from '../assets/IMG_2191.mp4'
import { useTranslation } from 'react-i18next'
import company from '../assets/companyy.jpg'
import services from '../assets/services.jpeg'
const Hero = lazy(() => import('../components/Hero'))
const Header = lazy(() => import('../components/Header'))
import er4 from '../assets/er4.png'

const About = () => {
  const { id } = useParams()
  const { t, i18n } = useTranslation('common')

  const scrollToDown = () => {
    window.scrollTo({
      top: 700,
      behavior: 'smooth',
    })
  }
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }, [id])
  useEffect(() => {
    scrollToDown()
  })
  return (
    <>
      <Box position="relative">
        <Box position="relative">
          <Box
            as="video"
            objectFit="cover"
            height={{ base: '650px', sm: '650px', md: '800px', xl: '100vh' }}
            loop
            muted
            width="100%"
            playsInline
            webkitplaysinline={true}
            autoPlay
            src={video}
          />
          <Box
            position="absolute"
            width="100%"
            bgColor="rgba(255,255,255,.1)"
            height={{ base: '650px', sm: '650px', md: '800px', xl: '100vh' }}
            top="0"
          >
            <Suspense fallback={
              // Subtle placeholder covering the hero area
              <Box position="absolute" top={0} w="100%" h={{ base: '650px', md: '800px', xl: '100vh' }}>
                <Skeleton height="100%" width="100%" startColor="gray.100" endColor="gray.200" />
              </Box>
            }>
              <Header t={t} i18n={i18n} />
              <Hero scrollTo={scrollToDown} title={t('pagesTitle.about')} />
            </Suspense>
          </Box>
        </Box>
        <Flex
          direction="column"
          margin={{ base: '100px auto', md: '100px auto' }}
          maxW={{ base: 'unset', md: '1600px' }}
        >
          <TextImageBlock
            withoutSeeMore
            title={t(`aboutpage.about.title`)}
            description={t(`aboutpage.about.description`)}
            imageUrl={company}
            imageOrder={{ base: '2', md: '1' }}
            textOrder="2"
            marginY="0px"
          />
          <TextImageBlock
            withoutSeeMore
            title={t(`aboutpage.product.title`)}
            description={t(`aboutpage.product.description`)}
            imageOrder={{ base: '1', md: '2' }}
            imageUrl={er4}
            textOrder="1"
            marginY="100px"
          />
          <TextImageBlock
            withoutSeeMore
            title={t(`aboutpage.service.title`)}
            description={t(`aboutpage.service.description`)}
            imageUrl={services}
            imageOrder={{ base: '2', md: '1' }}
            textOrder="2"
            marginY="0px"
          />
        </Flex>
      </Box>
      <Footer t={t} />
    </>
  )
}

export default About
